import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SchematicDataVM, ObservationPointVM, GenericIdName } from '../setup-implement/setup-implement.model';
import { DomSanitizer } from '@angular/platform-browser';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { NotificationsService } from 'angular2-notifications';
import { FileReaderEvent } from '../setup-implement/setup-implement.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'schemantic-op-popup',
    templateUrl: './schemantic-op-popup.component.html',
    styleUrls: ['./schemantic-op-popup.component.scss']
})
export class SchemanticOpPopupComponent implements OnInit {

    // from schemantic window


    @Input() positionX: string = "450";
    @Input() positionY: string = "500";
    @Input() schematic: SchematicDataVM = new SchematicDataVM();
    @Input() title: string = "Schematic";

    @Input() mouseoverMPId: number = 0;
    @Input() mouseoverOPId: number = 0;
    @Input() currentStep: number = 0;
    @Input() OPID: number = 0;

    @Input() CustomerId: number;
    @Input() ImplementId: number;
    @Output() mouseoverMP: EventEmitter<number> = new EventEmitter();
    @Output() mouseoverOP: EventEmitter<number> = new EventEmitter();
    @Output() closeSchematicWindow: EventEmitter<boolean> = new EventEmitter();
    @Output() closeObservationWindow: EventEmitter<boolean> = new EventEmitter();
    @Output() saveObservation: EventEmitter<boolean> = new EventEmitter();

    @Input() isTemplate: boolean = false;
    @Input() userUOM: string = "mm";
    eventX: number
    eventY: number
    //  window.
    showSchematic: boolean = false;
    schematicPositionX: number;
    schematicPositionY: number;

    // Mouse events for draggable schematic window.
    isMouseDown: boolean = false;
    prevMouseX: number;
    prevMouseY: number;
    selectedSchematic: SchematicDataVM;

    showAddObservation: boolean = false
    mouseclick: boolean = false
    makeTitle: string = "";
    machineModel: string = "";
    loading: boolean = false;

    TempObservationPoints: ObservationPointVM[];
    ComponentTypeVM: any[] = [0];
    ComponentTypeVMForm: FormControl = new FormControl(this.ComponentTypeVM);

    constructor(private _sanitizer: DomSanitizer, private toastr: NotificationsService,
        public openObservationPointModel: MatDialog, private _implementService: SetupImplementService,
        public dialogRef: MatDialogRef<SchemanticOpPopupComponent>,) { }


    ngOnInit() {
       this.TempObservationPoints = this.schematic.ObservationPoints;
        if (this.schematic.ImageName != null) {
            this.title = this.schematic.ImageName;
        }
        if (this.ImplementId > 0) {
          this.loadComponentTypes();
        }
       
        this.GetSchematicComponentType();

    }


    AddTempOP(event) {
        this.RemoveTempOP();
        var tempOP: ObservationPointVM = new ObservationPointVM();
        tempOP.PositionX = event.offsetX - 10;
       tempOP.PositionY = event.offsetY - 10;
        tempOP.Id = -1 
        this.TempObservationPoints.push(tempOP)
    }

    RemoveTempOP() {
        if (this.TempObservationPoints.find(x => x.Id == -1)) {
        this.TempObservationPoints.splice(this.TempObservationPoints.findIndex(x => x.WornPct == null), 1);
     }
   }
    //handle schemantic window

    onCloseSchematicWindow(e) {
        this.showSchematic = false;
        this.RemoveTempOP()
        this.saveObservation.emit(true);
    }

    onCloseObservationWindow(e) {
        this.RemoveTempOP()
        this.showAddObservation = false;
        this.saveObservation.emit(true);
        var newOP: ObservationPointVM = new ObservationPointVM();
        newOP.PositionX = this.eventX;
        newOP.PositionY = this.eventY;
        newOP.WornPct = 0;
        newOP.InspectionDate = "Never";
        newOP.Id = e;
        this.schematic.ObservationPoints.push(newOP);
    }
    
    getNewOpID(e) {
        this.OPID = e;
    }

    onCloseClick(): void {
        this.closeSchematicWindow.emit(true);
    }

    getImage(image: string) {
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }

    setWindowPosition(posX: string, posY: string) {
        return this._sanitizer.bypassSecurityTrustStyle('Left: ' + posX + 'px;' + 'Top: ' + posY + 'px;' + 'Position: absolute; z-index: 10;');
    }

    // getPosition(posX: string, posY: string) {
    //     var iPX = (parseFloat(posX));
    //     var iPY = (parseFloat(posY));
    //     return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
    // }
    // getPosition(x: number, y: number): { [key: string]: string } {
    //     var iPX = (x / 640.0) * 340;
    //     var iPY = (y / 520.0) * 270;
    //     return {
    //       position: 'absolute',   // Add this if necessary for positioning
    //       left: `${iPX}px`,
    //       top: `${iPY}px`
    //     };
    //   }
    
// getPosition(x: number, y: number): { [key: string]: string } {
//     var iPX = (x / 640.0) * 340;
//     var iPY = (y / 520.0) * 270;
//     return {
//       position: 'absolute',   // Add this if necessary for positioning
//       left: `${iPX}px`,
//       top: `${iPY}px`
//     };
//   }
getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));
    var iPY = (parseFloat(posY));
    return {
        position: 'absolute',   // Add this if necessary for positioning
        left: `${iPX}px`,
        top: `${iPY}px`
      };
    //return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  }
  
      getLine(posX: string, posY: string, EndposX: string, EndposY: string, isCrackFixed: boolean) {
        // bottom right
        var x1 = (parseFloat(posX))
        var y1 = (parseFloat(posY));
        // top right
        var x2 = (parseFloat(EndposX))
        var y2 = (parseFloat(EndposY));
        // distance
        var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
        // center
        var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
        var cy = ((y1 + y2) / 2) - (4 / 2);
        // angle
        var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
        // make hr
        var colour = isCrackFixed == false ? "#EC0A0A" : "#0000FF";
        return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 +
          'px; background-color:' + colour + '; line-height:1px; position:absolute; left:' + cx +
          'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');
    
      }

    getEval(wornPct: number, inspectDate: string) {
        if ((wornPct == 0) && (inspectDate == "Never")) {
            return 'gray';
        } else if (wornPct <= 30) {
            return 'green';
        } else if ((wornPct > 30) && (wornPct <= 60)) {
            return 'yellow';
        } else if ((wornPct > 60) && (wornPct <= 80)) {
            return 'orange';
        } else if (wornPct > 80) {
            return 'red';
        }
        else {
            return 'magenta';
        }
    }

    onMouseOverMP(id) {
        this.mouseoverMP.emit(id);
    }

    onMouseOutMP(id) {
        this.mouseoverMP.emit(0);
    }

    onMouseOverOP(id) {
        this.mouseoverOP.emit(id);
    }

    onMouseOutOP() {
        this.mouseoverOP.emit(0);
    }


    openObservationPointModal(event) {
        //this.RemoveTempOP()
        if ((this.schematic.Id > 0) && (this.currentStep == 2)) {
            this.showAddObservation = true;
            this.AddTempOP(event);
            
        } else if ((this.schematic.Id > 0)) {
            this.showAddObservation = true;
            this.AddTempOP(event);
            
        }
        else
            this.showAddObservation = false

        this.eventX = event.offsetX - 10;
        this.eventY = event.offsetY - 10;
        this.mouseclick = true
    }


    ReplaceImage(event: any) {
        console.log("info_", this.schematic)
        if (event.target.files && event.target.files[0]) {
          // this.updatePhoto(event.target.files[0]);
          const reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
            reader.onload = (event: any) => {
            //this.updatePhoto(event.target.result.split(',')[1]);

                const imageUrl = (event.target.result);
            //resize photo
            this.compressImage(imageUrl).then((res: string) => {
              // console.log("imageUrl", res)
              if (res) {
               //console.log('res', res)
    
                //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
                this.updatePhoto(res.split(',')[1]);
              }
            })
          };
        }
      }

    updatePhoto(newPhoto: string) {
        this._implementService.updateGETScematicImage(this.schematic.Id, newPhoto).subscribe(res => {
            console.log("res", res)
            if (res) {
                this.toastr.success("Successfully replaced the Schematic Image")
                this.schematic.Data = newPhoto;
            }
        })
      }

      compressImage(src) {
        return new Promise((res, rej) => {
          const img = new Image();
    
    
    
    
          img.src = src;
          img.onload = () => {
            const elem = document.createElement('canvas');
    
            let width, height;
            width = img.width;
            height = img.height;
    
            console.log('width', width)
            console.log('height', height)
    
            var ratio = height / width; //cal aspect ratio
            let imageWidth = 800;//643
            var new_height = imageWidth * ratio; //calculate new height
    
    
            elem.width = imageWidth;
            elem.height = new_height;
            const ctx = elem.getContext('2d');
            ctx.drawImage(img, 0, 0, imageWidth, new_height);
            const data = ctx.canvas.toDataURL();
            res(data);
          }
          img.onerror = error => rej(error);
        })
      }

	 //Component Type For Implements
     componentTypeList: GenericIdName[] = [];  
    componentType: number = 0
     loadComponentTypes() {
        this._implementService.GetComponentTypeListForSelectedImplement(this.ImplementId).subscribe(r => {
           this.componentTypeList = r;
            this.GetSchematicComponentTypeViewModelList();
       });
   }   
    UpdateComponentType() {
        console.log(this.schematic.Id, this.componentType)
        this._implementService.updateSchematicComponentType(this.schematic.Id, this.componentType, this.ImplementId).subscribe(r => {
        if (r) {
            this.toastr.success('Saved');
        } else {
            this.toastr.error('Unable to Update');
            }
        })
    }
           
    saveUpdateComponentType(ComponentTypeVM) {
        this.loading = true;

        this.ComponentTypeVM = this.ComponentTypeVMForm.value;
        console.log(this.schematic.Id, this.componentType);
        const schematicComponentTypeModelsList: any[] = [];
        for (let items of this.ComponentTypeVM) {
            var x = {
                SchematicId: this.schematic.Id,
                componentTypeId: items,
                ImplementId: this.ImplementId
            };
            schematicComponentTypeModelsList.push(x)
        }
        this._implementService.saveUpdateComponentType(schematicComponentTypeModelsList).subscribe(r => {
            if (r) {
                this.loading = false;
                this.toastr.success('Saved');
                this.saveObservation.emit(true);
                this.closeSchematicWindow.emit(true);
            } else {
                this.toastr.error('Unable to Update');
        }
    })   
   }   


    GetSchematicComponentType() {
        this._implementService.GetSchematicComponentType(this.schematic.Id).subscribe(res => {
            this.componentType = res;
           
       })
   }
    GetSchematicComponentTypeViewModelList() {
        debugger;
        this.ComponentTypeVM = [];
        this.loading = true;
        console.log("this.schematic.Id:", this.schematic.Id);
        this._implementService.GetSchematicComponentTypeViewModelList(this.schematic.Id, this.ImplementId).subscribe(res => {
            debugger;
            res.forEach(x => {
                this.ComponentTypeVM.push(x.Id);
            });
            this.ComponentTypeVMForm = new FormControl(this.ComponentTypeVM);

      
            this.loadForms();
            this.loading = false; // Move it here to ensure it's set after data is loaded.
        });
        
    }
    
    loadForms(){

    }
    // GetSchematicComponentTypeViewModelList() {
    //     debugger;
    //     this.ComponentTypeVM = [];
    //     this.loading = true;
    //     this._implementService.GetSchematicComponentTypeViewModelList(this.schematic.Id).subscribe(res => {
    //         debugger;
    //         res.forEach(x => {
    //             this.ComponentTypeVM.push(x.Id);
    //           })
    //     })

    //     this.loading = false
    // }

    UpdateSchmaticImageName() {
        this._implementService.UpdateSchmaticImageName(this.schematic.Id, this.title).subscribe(res => {
            if (res > 0)
        this.toastr.success("Updated successfully")
    })
}

    onDragStart() {
    console.log("got drag start");
  }
    onDragMove(event: PointerEvent) {
     console.log(`got drag move ${Math.round(event.clientX)} ${Math.round(event.clientY)}`);
  }
    onDragEnd() {
    console.log('got drag end');
  }
}
